import { defineComponent, toRef, ref, watch } from '@vue/composition-api';
import { useTheme } from '../theme/useTheme.js';
import { getAssetsDomain } from '../assets/assetsDomain.js';

var script = defineComponent({
    name: 'Icon',
    props: {
        size: {
            type: String,
            required: false,
            default: 'md',
        },
        iconName: {
            type: String,
            required: true,
        },
        isThemed: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup: function (props) {
        var isThemed = toRef(props, 'isThemed');
        var iconName = toRef(props, 'iconName');
        var imageUrl = ref('');
        var themeSuffix = useTheme().themeSuffix;
        var getIconUrl = function () {
            try {
                if (!isThemed.value) {
                    return;
                }
                imageUrl.value = "".concat(getAssetsDomain(), "/app-assets/sds-icons-multi-color/").concat(iconName.value, "-").concat(themeSuffix.value, ".svg");
            }
            catch (error) {
                console.warn(error);
                imageUrl.value = '';
            }
        };
        watch([themeSuffix, isThemed, iconName], function () {
            getIconUrl();
        }, { immediate: true });
        return {
            imageUrl: imageUrl,
        };
    }
});

export default script;
